import { QueryClient } from '@tanstack/react-query';

/**
 * Single QueryClient for the SPA — created once at module scope so the
 * cache survives route transitions. Defaults tuned for a dashboard app :
 * short staleTime (live data arrives over the office WebSocket anyway),
 * one retry, no focus refetch storm.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      // Retry once for transient/server errors, but NEVER for 4xx — an
      // auth/permission/not-found response won't change on retry, and
      // retrying a 401 just doubles the failed requests (+ the /login
      // redirect storm) while the session is invalid.
      retry: (failureCount, error) => {
        const status = error?.status;
        if (typeof status === 'number' && status >= 400 && status < 500) return false;
        return failureCount < 1;
      },
      refetchOnWindowFocus: false,
    },
  },
});
